module.exports = __webpack_public_path__ + "static/welcome-38afd603619de4971a21585e1fbaaf8e.jpg";